








































































































































import Vue from "vue";
import moment from "moment";

import { MODULE_COLORS } from "@/utility/Constants";

import { AddTemplateCommand, AddTemplateReqData } from "@/model/communication/caosConfiguration/AddTemplateCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { CaosConfigurationTemplateContentsEnum, caosConfigurationTemplateContentToString } from "@/model/data/enums/CaosConfigurationTemplateContentsEnum";
import { CaosConfigurationTemplate } from "@/model/data/caosConfiguration/CaosConfigurationTemplate";
import { ADD_ALERT } from "@/store/modules/AlertModule/mutations";
import { mapMutations } from "vuex";
import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";

export default Vue.extend({
    props: {
        showDialog: Boolean,
        baseConfiguration: Object,
        caosVersion: String,
        installation: String,
        loading: Boolean,
        error: Boolean,
        errorMessage: String,
        availableConfigSections: Array,
    },
    data() {
        return {
            moment,
            MODULE_COLORS,
            selectedContent: [],
            loadingAddTemplate: false,
            CaosConfigurationTemplateContentsEnum,
            newTemplate: null,
        };
    },
    watch: {
        installation(value) {
            if (value) {
                this.newTemplate = new CaosConfigurationTemplate();
                this.newTemplate.sourceInstallationName = this.installation;
                this.newTemplate.caosVersion = this.caosVersion;
                this.selectedContent = [];
            }
        },
    },
    computed: {
        showAddTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
        canAdd() {
            if (!this.selectedContent || this.selectedContent.length < 1 || this.templateContentRequiresValid != "" || !this.newTemplate.name) return false;

            return true;
        },
        selectAllIcon() {
            return this.selectedContent.length == this.availableConfigSections.length ? "fa-check-square" : "far fa-square";
        },
        templateContentRequiresValid() {
            if (this.selectedContent && this.selectedContent.length > 0) {
                for (let content of this.selectedContent) {
                    let section: string = CaosConfigurationTemplateContentsEnum[content];
                    let requirements: string[] = this.baseConfiguration[section].requires;
                    if (requirements && requirements.length > 0) {
                        for (let requirement of requirements) {
                            if (!this.selectedContent.includes(CaosConfigurationTemplateContentsEnum[requirement])) {
                                let sectioni18n = this.$t(caosConfigurationTemplateContentToString(content));
                                let requirement18n = this.$t(caosConfigurationTemplateContentToString(CaosConfigurationTemplateContentsEnum[requirement]));
                                return this.$t("caosTemplate.contentRequirement", { section: sectioni18n, requirement: requirement18n });
                            }
                        }
                    }
                }
            }
            return "";
        },
    },
    methods: {
        ...mapMutations([ADD_ALERT]),

        async sendRequestCreateTemplate() {
            let templateContent = CaosConfigurationTemplateContentsEnum.none;
            this.selectedContent.forEach((content) => {
                templateContent |= content;
            });
            this.newTemplate.templateContent = templateContent;
            this.loadingAddTemplate = true;
            let reqData = new AddTemplateReqData(this.newTemplate);
            let response: ApiGenericResponse = await new AddTemplateCommand(reqData).execute();
            let endingMessage = "";
            let alertType = AlertModelType.Error;
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                alertType = AlertModelType.Success;
                endingMessage = this.$t("caosTemplate.addTemplateSuccess", { name: this.newTemplate.name });
            } else {
                endingMessage = this.$t("caosTemplate.addTemplateError", { name: this.newTemplate.name });
            }
            this[ADD_ALERT](new AlertModel(alertType, endingMessage));
            this.loadingAddTemplate = false;
            this.showAddTemplateDialog = false;
        },
        onSelectAllClick() {
            if (this.selectedContent != null && this.availableConfigSections != null && this.selectedContent.length == this.availableConfigSections.length) {
                this.selectedContent = [];
            } else {
                this.selectedContent = this.availableConfigSections.map((c) => c.contentValue);
            }
        },
    },
});
